import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles.css';

// Apply saved theme before first render to avoid flash
const savedDark = localStorage.getItem('pref_darkMode');
document.body.setAttribute('data-theme', savedDark === 'false' ? 'light' : 'dark');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
